import classNames from 'classnames';
import { get } from 'lodash';

import CustomAddButton from '../buttons/custom-add-button';
import CustomMinusButton from '../buttons/custom-minus-button';

import StringUtils from '../../../utils/StringUtils';
import useStyles from './styles';

import type { BaseProps } from '../../../interfaces';

export function CustomMeasureValueSelector(props: Props) {
  const {
    value,
    maxValue,
    minValue,
    measureText,
    onIncrease,
    onDecrease,
    classes = {},
  } = props;
  const componentClasses = useStyles();
  return (
    <div
      className={classNames(componentClasses.root, get(classes, 'root', null))}
    >
      <CustomMinusButton
        classes={{
          icon: classNames(componentClasses.icon, get(classes, 'icon', null)),
          button: classNames(
            componentClasses.button,
            get(classes, 'button', null),
          ),
        }}
        disabled={value <= minValue}
        onClick={onDecrease}
      />

      <div
        className={classNames(
          componentClasses.measureValueContainer,
          get(classes, 'measureValueContainer', null),
        )}
      >
        <span
          className={classNames(
            componentClasses.value,
            get(classes, 'value', null),
          )}
        >
          {value}
        </span>
        {!StringUtils.isNullOrEmpty(measureText) && (
          <span
            className={classNames(
              componentClasses.measure,
              get(classes, 'measure', null),
            )}
          >
            {measureText}
          </span>
        )}
      </div>
      <CustomAddButton
        classes={{
          icon: classNames(componentClasses.icon, get(classes, 'icon', null)),
          button: classNames(
            componentClasses.button,
            get(classes, 'button', null),
          ),
        }}
        disabled={value >= maxValue}
        onClick={onIncrease}
      />
    </div>
  );
}

interface Props extends BaseProps {
  value: number;
  minValue: number;
  maxValue: number;
  measureText?: string;
  onDecrease: () => void;
  onIncrease: () => void;
}
